export const SNACK_SET = 'SNACK_SET';

export const GET_PLANS_REQUEST = 'GET_PLANS_REQUEST';
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS';
export const GET_PLANS_FAILURE = 'GET_PLANS_FAILURE';

export const RESET_PLANS_STATE = 'RESET_PLANS_STATE';

export const CREATE_ANNUAL_PLAN_REQUEST = 'CREATE_ANNUAL_PLAN_REQUEST';
export const CREATE_ANNUAL_PLAN_SUCCESS = 'CREATE_ANNUAL_PLAN_SUCCESS';
export const CREATE_ANNUAL_PLAN_FAILURE = 'CREATE_ANNUAL_PLAN_FAILURE';

export const GET_ANNUAL_PLANS_REQUEST = 'GET_ANNUAL_PLANS_REQUEST';
export const GET_ANNUAL_PLANS_SUCCESS = 'GET_ANNUAL_PLANS_SUCCESS';
export const GET_ANNUAL_PLANS_FAILURE = 'GET_ANNUAL_PLANS_FAILURE';

export const GET_ANNUAL_PLAN_REQUEST = 'GET_ANNUAL_PLAN_REQUEST';
export const GET_ANNUAL_PLAN_SUCCESS = 'GET_ANNUAL_PLAN_SUCCESS';
export const GET_ANNUAL_PLAN_FAILURE = 'GET_ANNUAL_PLAN_FAILURE';

export const DELETE_ANNUAL_PLAN_REQUEST = 'DELETE_ANNUAL_PLAN_REQUEST';
export const DELETE_ANNUAL_PLAN_SUCCESS = 'DELETE_ANNUAL_PLAN_SUCCESS';
export const DELETE_ANNUAL_PLAN_FAILURE = 'DELETE_ANNUAL_PLAN_FAILURE';

export const UPDATE_ANNUAL_PLAN_REQUEST = 'UPDATE_ANNUAL_PLAN_REQUEST';
export const UPDATE_ANNUAL_PLAN_SUCCESS = 'UPDATE_ANNUAL_PLAN_SUCCESS';
export const UPDATE_ANNUAL_PLAN_FAILURE = 'UPDATE_ANNUAL_PLAN_FAILURE';
export const SAVE_PLAN_REQUIREMENT_DECISIONS_REQUEST = 'SAVE_PLAN_REQUIREMENT_DECISIONS_REQUEST';
export const SAVE_PLAN_REQUIREMENT_DECISIONS_SUCCESS = 'SAVE_PLAN_REQUIREMENT_DECISIONS_SUCCESS';
export const SAVE_PLAN_REQUIREMENT_DECISIONS_FAILURE = 'SAVE_PLAN_REQUIREMENT_DECISIONS_FAILURE';
export const GET_PLAN_REQUIREMENT_DECISIONS_REQUEST = 'GET_PLAN_REQUIREMENT_DECISIONS_REQUEST';
export const GET_PLAN_REQUIREMENT_DECISIONS_SUCCESS = 'GET_PLAN_REQUIREMENT_DECISIONS_SUCCESS';
export const GET_PLAN_REQUIREMENT_DECISIONS_FAILURE = 'GET_PLAN_REQUIREMENT_DECISIONS_FAILURE';
export const SET_SELECTED_HIERARCHICAL_MODEL = 'SET_SELECTED_HIERARCHICAL_MODEL';
export const SET_CURRENT_PLAN_ID = 'SET_CURRENT_PLAN_ID';

export const RESET_ANNUAL_PLAN_V2_STATE = 'RESET_ANNUAL_PLAN_V2_STATE';

export const GET_FOCUSES_REQUEST = 'GET_FOCUSES_REQUEST';
export const GET_FOCUSES_SUCCESS = 'GET_FOCUSES_SUCCESS';
export const GET_FOCUSES_FAILURE = 'GET_FOCUSES_FAILURE';
export const GET_FOCUSES_FULFILLMENT_PROGRESS_REQUEST = 'GET_FOCUSES_FULFILLMENT_PROGRESS_REQUEST';
export const GET_FOCUSES_FULFILLMENT_PROGRESS_SUCCESS = 'GET_FOCUSES_FULFILLMENT_PROGRESS_SUCCESS';
export const GET_FOCUSES_FULFILLMENT_PROGRESS_FAILURE = 'GET_FOCUSES_FULFILLMENT_PROGRESS_FAILURE';

export const CREATE_FOCUS_REQUEST = 'CREATE_FOCUS_REQUEST';
export const CREATE_FOCUS_SUCCESS = 'CREATE_FOCUS_SUCCESS';
export const CREATE_FOCUS_FAILURE = 'CREATE_FOCUS_FAILURE';

export const RESET_FOCUSES_STATE = 'RESET_FOCUSES_STATE';

export const GET_OBJECTIVES_REQUEST = 'GET_OBJECTIVES_REQUEST';
export const GET_OBJECTIVES_SUCCESS = 'GET_OBJECTIVES_SUCCESS';
export const GET_OBJECTIVES_FAILURE = 'GET_OBJECTIVES_FAILURE';

export const CREATE_OBJECTIVE_REQUEST = 'CREATE_OBJECTIVE_REQUEST';
export const CREATE_OBJECTIVE_SUCCESS = 'CREATE_OBJECTIVE_SUCCESS';
export const CREATE_OBJECTIVE_FAILURE = 'CREATE_OBJECTIVE_FAILURE';

export const UPDATE_OBJECTIVE_REQUEST = 'UPDATE_OBJECTIVE_REQUEST';
export const UPDATE_OBJECTIVE_SUCCESS = 'UPDATE_OBJECTIVE_SUCCESS';
export const UPDATE_OBJECTIVE_FAILURE = 'UPDATE_OBJECTIVE_FAILURE';

export const DELETE_OBJECTIVE_REQUEST = 'DELETE_OBJECTIVE_REQUEST';
export const DELETE_OBJECTIVE_SUCCESS = 'DELETE_OBJECTIVE_SUCCESS';
export const DELETE_OBJECTIVE_FAILURE = 'DELETE_OBJECTIVE_FAILURE';

export const RESET_OBJECTIVES_STATE = 'RESET_OBJECTIVES_STATE';

export const GET_ACTIVITIES_REQUEST = 'GET_ACTIVITIES_REQUEST';
export const GET_ACTIVITIES_SUCCESS = 'GET_ACTIVITIES_SUCCESS';
export const GET_ACTIVITIES_FAILURE = 'GET_ACTIVITIES_FAILURE';

export const CREATE_ACTIVITY_REQUEST = 'CREATE_ACTIVITY_REQUEST';
export const CREATE_ACTIVITY_SUCCESS = 'CREATE_ACTIVITY_SUCCESS';
export const CREATE_ACTIVITY_FAILURE = 'CREATE_ACTIVITY_FAILURE';

export const UPDATE_ACTIVITY_REQUEST = 'UPDATE_ACTIVITY_REQUEST';
export const UPDATE_ACTIVITY_SUCCESS = 'UPDATE_ACTIVITY_SUCCESS';
export const UPDATE_ACTIVITY_FAILURE = 'UPDATE_ACTIVITY_FAILURE';

export const DELETE_ACTIVITY_REQUEST = 'DELETE_ACTIVITY_REQUEST';
export const DELETE_ACTIVITY_SUCCESS = 'DELETE_ACTIVITY_SUCCESS';
export const DELETE_ACTIVITY_FAILURE = 'DELETE_ACTIVITY_FAILURE';

export const RESET_ACTIVITIES_STATE = 'RESET_ACTIVITIES_STATE';

export const GET_EXTERNAL_DATA_REQUEST = 'GET_EXTERNAL_DATA_REQUEST';
export const GET_EXTERNAL_DATA_SUCCESS = 'GET_EXTERNAL_DATA_SUCCESS';
export const GET_EXTERNAL_DATA_FAILURE = 'GET_EXTERNAL_DATA_FAILURE';

export const RESET_EXTERNAL_DATA_STATE = 'RESET_EXTERNAL_DATA_STATE';

export const GET_REQUIREMENTS_REQUEST = 'GET_REQUIREMENTS_REQUEST';
export const GET_REQUIREMENTS_SUCCESS = 'GET_REQUIREMENTS_SUCCESS';
export const GET_REQUIREMENTS_FAILURE = 'GET_REQUIREMENTS_FAILURE';

export const RESET_REQUIREMENTS_STATE = 'RESET_REQUIREMENTS_STATE';

export const GET_CHECKLISTS_REQUEST = 'GET_CHECKLISTS_REQUEST';
export const GET_CHECKLISTS_SUCCESS = 'GET_CHECKLISTS_SUCCESS';
export const GET_CHECKLISTS_FAILURE = 'GET_CHECKLISTS_FAILURE';
export const SAVE_CHECKLIST_RESPONSES_REQUEST = 'SAVE_CHECKLIST_RESPONSES_REQUEST';
export const SAVE_CHECKLIST_RESPONSES_SUCCESS = 'SAVE_CHECKLIST_RESPONSES_SUCCESS';
export const SAVE_CHECKLIST_RESPONSES_FAILURE = 'SAVE_CHECKLIST_RESPONSES_FAILURE';

export const RESET_CHECKLISTS_STATE = 'RESET_CHECKLISTS_STATE';

export const APPROVE_DEFINITIONS_REQUEST = 'APPROVE_DEFINITIONS_REQUEST';
export const APPROVE_DEFINITIONS_SUCCESS = 'APPROVE_DEFINITIONS_SUCCESS';
export const APPROVE_DEFINITIONS_FAILURE = 'APPROVE_DEFINITIONS_FAILURE';

export const EXPORT_ANNUAL_PLANS_CSV_REQUEST = 'EXPORT_ANNUAL_PLANS_CSV_REQUEST';
export const EXPORT_ANNUAL_PLANS_CSV_SUCCESS = 'EXPORT_ANNUAL_PLANS_CSV_SUCCESS';
export const EXPORT_ANNUAL_PLANS_CSV_FAILURE = 'EXPORT_ANNUAL_PLANS_CSV_FAILURE';

export const EXPORT_ANNUAL_PLANS_EXCEL_REQUEST = 'EXPORT_ANNUAL_PLANS_EXCEL_REQUEST';
export const EXPORT_ANNUAL_PLANS_EXCEL_SUCCESS = 'EXPORT_ANNUAL_PLANS_EXCEL_SUCCESS';
export const EXPORT_ANNUAL_PLANS_EXCEL_FAILURE = 'EXPORT_ANNUAL_PLANS_EXCEL_FAILURE';

export const ADD_FOCUS_DEFINITION_APPROVAL_REQUEST = 'ADD_FOCUS_DEFINITION_APPROVAL_REQUEST';
export const ADD_FOCUS_DEFINITION_APPROVAL_SUCCESS = 'ADD_FOCUS_DEFINITION_APPROVAL_SUCCESS';
export const ADD_FOCUS_DEFINITION_APPROVAL_FAILURE = 'ADD_FOCUS_DEFINITION_APPROVAL_FAILURE';

export const ADD_PLAN_DEFINITION_APPROVAL_REQUEST = 'ADD_PLAN_DEFINITION_APPROVAL_REQUEST';
export const ADD_PLAN_DEFINITION_APPROVAL_SUCCESS = 'ADD_PLAN_DEFINITION_APPROVAL_SUCCESS';
export const ADD_PLAN_DEFINITION_APPROVAL_FAILURE = 'ADD_PLAN_DEFINITION_APPROVAL_FAILURE';

export const GET_FOCUS_DEFINITION_APPROVALS_REQUEST = 'GET_FOCUS_DEFINITION_APPROVALS_REQUEST';
export const GET_FOCUS_DEFINITION_APPROVALS_SUCCESS = 'GET_FOCUS_DEFINITION_APPROVALS_SUCCESS';
export const GET_FOCUS_DEFINITION_APPROVALS_FAILURE = 'GET_FOCUS_DEFINITION_APPROVALS_FAILURE';

export const GET_PLAN_DEFINITION_APPROVAL_REQUEST = 'GET_PLAN_DEFINITION_APPROVAL_REQUEST';
export const GET_PLAN_DEFINITION_APPROVAL_SUCCESS = 'GET_PLAN_DEFINITION_APPROVAL_SUCCESS';
export const GET_PLAN_DEFINITION_APPROVAL_FAILURE = 'GET_PLAN_DEFINITION_APPROVAL_FAILURE';

export const SET_CURRENT_VERSION = 'SET_CURRENT_VERSION';

export const CREATE_FULFILLMENT_VERSION_REQUEST = 'CREATE_FULFILLMENT_VERSION_REQUEST';
export const CREATE_FULFILLMENT_VERSION_SUCCESS = 'CREATE_FULFILLMENT_VERSION_SUCCESS';
export const CREATE_FULFILLMENT_VERSION_FAILURE = 'CREATE_FULFILLMENT_VERSION_FAILURE';

export const SET_FULFILLMENT_VERSION = 'SET_FULFILLMENT_VERSION';

export const SET_CURRENT_BUSINESS_UNIT = 'SET_CURRENT_BUSINESS_UNIT';

export const MARK_PLAN_VERSION_FOR_APPROVAL_REQUEST = 'MARK_PLAN_VERSION_FOR_APPROVAL_REQUEST';
export const MARK_PLAN_VERSION_FOR_APPROVAL_SUCCESS = 'MARK_PLAN_VERSION_FOR_APPROVAL_SUCCESS';
export const MARK_PLAN_VERSION_FOR_APPROVAL_FAILURE = 'MARK_PLAN_VERSION_FOR_APPROVAL_FAILURE';

export const MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_REQUEST =
  'MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_REQUEST';
export const MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_SUCCESS =
  'MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_SUCCESS';
export const MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_FAILURE =
  'MARK_PLAN_FULFILLMENT_VERSION_FOR_APPROVAL_FAILURE';

export const ADD_FOCUS_FULFILLMENT_VALIDATION_REQUEST = 'ADD_FOCUS_FULFILLMENT_VALIDATION_REQUEST';
export const ADD_FOCUS_FULFILLMENT_VALIDATION_SUCCESS = 'ADD_FOCUS_FULFILLMENT_VALIDATION_SUCCESS';
export const ADD_FOCUS_FULFILLMENT_VALIDATION_FAILURE = 'ADD_FOCUS_FULFILLMENT_VALIDATION_FAILURE';

export const ADD_PLAN_VALIDATION_REQUEST = 'ADD_PLAN_VALIDATION_REQUEST';
export const ADD_PLAN_VALIDATION_SUCCESS = 'ADD_PLAN_VALIDATION_SUCCESS';
export const ADD_PLAN_VALIDATION_FAILURE = 'ADD_PLAN_VALIDATION_FAILURE';
export const UPLOAD_PLAN_SIGNATURE_REQUEST = 'UPLOAD_PLAN_SIGNATURE_REQUEST';
export const UPLOAD_PLAN_SIGNATURE_SUCCESS = 'UPLOAD_PLAN_SIGNATURE_SUCCESS';
export const UPLOAD_PLAN_SIGNATURE_FAILURE = 'UPLOAD_PLAN_SIGNATURE_FAILURE';
export const GET_FOCUS_FULFILLMENT_VALIDATIONS_REQUEST =
  'GET_FOCUS_FULFILLMENT_VALIDATIONS_REQUEST';
export const GET_FOCUS_FULFILLMENT_VALIDATIONS_SUCCESS =
  'GET_FOCUS_FULFILLMENT_VALIDATIONS_SUCCESS';
export const GET_FOCUS_FULFILLMENT_VALIDATIONS_FAILURE =
  'GET_FOCUS_FULFILLMENT_VALIDATIONS_FAILURE';

export const GET_PLAN_VALIDATION_REQUEST = 'GET_PLAN_VALIDATION_REQUEST';
export const GET_PLAN_VALIDATION_SUCCESS = 'GET_PLAN_VALIDATION_SUCCESS';
export const GET_PLAN_VALIDATION_FAILURE = 'GET_PLAN_VALIDATION_FAILURE';

export const REOPEN_PLAN_VERSION_REQUEST = 'REOPEN_PLAN_VERSION_REQUEST';
export const REOPEN_PLAN_VERSION_SUCCESS = 'REOPEN_PLAN_VERSION_SUCCESS';
export const REOPEN_PLAN_VERSION_FAILURE = 'REOPEN_PLAN_VERSION_FAILURE';

export const REOPEN_FULFILLMENT_VERSION_REQUEST = 'REOPEN_FULFILLMENT_VERSION_REQUEST';
export const REOPEN_FULFILLMENT_VERSION_SUCCESS = 'REOPEN_FULFILLMENT_VERSION_SUCCESS';
export const REOPEN_FULFILLMENT_VERSION_FAILURE = 'REOPEN_FULFILLMENT_VERSION_FAILURE';

export const SET_READ_ONLY_MODE = 'SET_READ_ONLY_MODE';
export const SET_CREATING_OUT_OF_TIME_PLAN = 'SET_CREATING_OUT_OF_TIME_PLAN';

export const SET_AP_YEAR = 'SET_AP_YEAR';

export const ANULAR_PLAN_VERSION_REQUEST = 'ANULAR_PLAN_VERSION_REQUEST';
export const ANULAR_PLAN_VERSION_SUCCESS = 'ANULAR_PLAN_VERSION_SUCCESS';
export const ANULAR_PLAN_VERSION_FAILURE = 'ANULAR_PLAN_VERSION_FAILURE';

export const RETURN_PLAN_TO_DEFINITION_REQUEST = 'RETURN_PLAN_TO_DEFINITION_REQUEST';
export const RETURN_PLAN_TO_DEFINITION_SUCCESS = 'RETURN_PLAN_TO_DEFINITION_SUCCESS';
export const RETURN_PLAN_TO_DEFINITION_FAILURE = 'RETURN_PLAN_TO_DEFINITION_FAILURE';

export const GET_ACTIVITIES_BY_PLAN_ID_REQUEST = 'GET_ACTIVITIES_BY_PLAN_ID_REQUEST';
export const GET_ACTIVITIES_BY_PLAN_ID_SUCCESS = 'GET_ACTIVITIES_BY_PLAN_ID_SUCCESS';
export const GET_ACTIVITIES_BY_PLAN_ID_FAILURE = 'GET_ACTIVITIES_BY_PLAN_ID_FAILURE';

export const CHECKLIST_RESPONSES_REQUEST = 'CHECKLIST_RESPONSES_REQUEST';
export const CHECKLIST_RESPONSES_SUCCESS = 'CHECKLIST_RESPONSES_SUCCESS';
export const CHECKLIST_RESPONSES_FAILURE = 'CHECKLIST_RESPONSES_FAILURE';

export const GET_SELF_ASSESSMENT_RESULTS_REQUEST = 'GET_SELF_ASSESSMENT_RESULTS_REQUEST';
export const GET_SELF_ASSESSMENT_RESULTS_SUCCESS = 'GET_SELF_ASSESSMENT_RESULTS_SUCCESS';
export const GET_SELF_ASSESSMENT_RESULTS_FAILURE = 'GET_SELF_ASSESSMENT_RESULTS_FAILURE';

export const GET_USER_ROLES_REQUEST = 'GET_USER_ROLES_REQUEST';
export const GET_USER_ROLES_SUCCESS = 'GET_USER_ROLES_SUCCESS';
export const GET_USER_ROLES_FAILURE = 'GET_USER_ROLES_FAILURE';

export const GET_OUT_OF_TIME_REQUEST_STATUS_REQUEST = 'GET_OUT_OF_TIME_REQUEST_STATUS_REQUEST';
export const GET_OUT_OF_TIME_REQUEST_STATUS_SUCCESS = 'GET_OUT_OF_TIME_REQUEST_STATUS_SUCCESS';
export const GET_OUT_OF_TIME_REQUEST_STATUS_FAILURE = 'GET_OUT_OF_TIME_REQUEST_STATUS_FAILURE';

export const SUBMIT_OUT_OF_TIME_REQUEST_REQUEST = 'SUBMIT_OUT_OF_TIME_REQUEST_REQUEST';
export const SUBMIT_OUT_OF_TIME_REQUEST_SUCCESS = 'SUBMIT_OUT_OF_TIME_REQUEST_SUCCESS';
export const SUBMIT_OUT_OF_TIME_REQUEST_FAILURE = 'SUBMIT_OUT_OF_TIME_REQUEST_FAILURE';

export const PROCESS_OUT_OF_TIME_DECISION_REQUEST = 'PROCESS_OUT_OF_TIME_DECISION_REQUEST';
export const PROCESS_OUT_OF_TIME_DECISION_SUCCESS = 'PROCESS_OUT_OF_TIME_DECISION_SUCCESS';
export const PROCESS_OUT_OF_TIME_DECISION_FAILURE = 'PROCESS_OUT_OF_TIME_DECISION_FAILURE';

export const PROCESS_REOPEN_TOKEN_DECISION_REQUEST = 'PROCESS_REOPEN_TOKEN_DECISION_REQUEST';
export const PROCESS_REOPEN_TOKEN_DECISION_SUCCESS = 'PROCESS_REOPEN_TOKEN_DECISION_SUCCESS';
export const PROCESS_REOPEN_TOKEN_DECISION_FAILURE = 'PROCESS_REOPEN_TOKEN_DECISION_FAILURE';
